const MANGUERAS_COMBUSTIBLE_1 = [
  {
    idManguera: 4,
    descripcion: "3 - NAFTA SUPER XXI",
  },
  {
    idManguera: 8,
    descripcion: "7 - NAFTA SUPER XXI",
  },
  {
    idManguera: 12,
    descripcion: "11 - NAFTA SUPER XXI",
  },
  {
    idManguera: 16,
    descripcion: "15 - NAFTA SUPER XXI",
  },
  {
    idManguera: 18,
    descripcion: "17 - NAFTA SUPER XXI",
  },
  {
    idManguera: 19,
    descripcion: "19 - NAFTA SUPER XXI",
  },
  {
    idManguera: 22,
    descripcion: "23 - NAFTA SUPER XXI",
  },
  {
    idManguera: 26,
    descripcion: "27 - NAFTA SUPER XXI",
  },
];

const MANGUERAS_COMBUSTIBLE_2 = [
  {
    idManguera: 5,
    descripcion: "4 - INFINIA",
  },
  {
    idManguera: 9,
    descripcion: "8 - INFINIA",
  },
  {
    idManguera: 13,
    descripcion: "12 - INFINIA",
  },
  {
    idManguera: 17,
    descripcion: "16 - INFINIA",
  },
  {
    idManguera: 38,
    descripcion: "18 - INFINIA",
  },
  {
    idManguera: 39,
    descripcion: "20 - INFINIA",
  },
  {
    idManguera: 23,
    descripcion: "24 - INFINIA",
  },
  {
    idManguera: 27,
    descripcion: "28 - INFINIA",
  },
];

const MANGUERAS_COMBUSTIBLE_3 = [
  {
    idManguera: 3,
    descripcion: "2 - GO-INFINIA DIESEL",
  },
  {
    idManguera: 7,
    descripcion: "6 - GO-INFINIA DIESEL",
  },
  {
    idManguera: 11,
    descripcion: "10 - GO-INFINIA DIESEL",
  },
  {
    idManguera: 15,
    descripcion: "14 - GO-INFINIA DIESEL",
  },
  {
    idManguera: 21,
    descripcion: "22 - GO-INFINIA DIESEL",
  },
  {
    idManguera: 25,
    descripcion: "26 - GO-INFINIA DIESEL",
  },
];

const MANGUERAS_COMBUSTIBLE_4 = [
  {
    idManguera: 2,
    descripcion: "1 - D. DIESEL 500",
  },
  {
    idManguera: 6,
    descripcion: "5 - D. DIESEL 500",
  },
  {
    idManguera: 10,
    descripcion: "9 - D. DIESEL 500",
  },
  {
    idManguera: 14,
    descripcion: "13 - D. DIESEL 500",
  },
  {
    idManguera: 20,
    descripcion: "21 - D. DIESEL 500",
  },
  {
    idManguera: 24,
    descripcion: "25 - D. DIESEL 500",
  },
];

const MANGUERAS_COMBUSTIBLE_5 = [
  {
    idManguera: 33,
    descripcion: "34 - SUPER 20W50 GR",
  },
  {
    idManguera: 34,
    descripcion: "35 - SUPER 20W50 GR",
  },
  {
    idManguera: 36,
    descripcion: "37 - SUPER 20W50 GR",
  },
  {
    idManguera: 37,
    descripcion: "38 - SUPER 20W50 GR",
  },
];

const MANGUERAS_COMBUSTIBLE_6 = [
  {
    idManguera: 32,
    descripcion: "33 - HD SUPLEMENTO 1 40 GR GNC",
  },
  {
    idManguera: 35,
    descripcion: "36 - HD SUPLEMENTO 1 40 GR GNC",
  },
];

const MANGUERAS_COMBUSTIBLE_7 = [
  {
    idManguera: 28,
    descripcion: "29 - GNC",
  },
  {
    idManguera: 30,
    descripcion: "30 - GNC",
  },
  {
    idManguera: 29,
    descripcion: "31 - GNC",
  },
  {
    idManguera: 31,
    descripcion: "32 - GNC",
  },
];

const combustible = async idCombustible => {
  if (idCombustible === 2) {
    return MANGUERAS_COMBUSTIBLE_1;
  }
  if (idCombustible === 3) {
    return MANGUERAS_COMBUSTIBLE_2;
  }
  if (idCombustible === 4) {
    return MANGUERAS_COMBUSTIBLE_3;
  }
  if (idCombustible === 5) {
    return MANGUERAS_COMBUSTIBLE_4;
  }
  if (idCombustible === 81) {
    return MANGUERAS_COMBUSTIBLE_5;
  }
  if (idCombustible === 104) {
    return MANGUERAS_COMBUSTIBLE_6;
  }
  if (idCombustible === 1438) {
    return MANGUERAS_COMBUSTIBLE_7;
  }
};

const mangueras = {
  combustible,
};

export default mangueras;
